// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-01fbe780]{height:42.969vw;width:49.479vw;position:relative}#midCanvasm[data-v-01fbe780]{z-index:1000}#dhCanvasm[data-v-01fbe780],#midCanvasm[data-v-01fbe780]{position:absolute;top:0;left:0}#dhCanvasm[data-v-01fbe780]{z-index:10001}", ""]);
// Exports
module.exports = exports;
